import React, {useEffect, useRef, useState} from 'react'
import {Image} from 'react-konva'
import {useImagePadding} from '../../../../hooks/useImagePadding'

const BackgroundLayer = ({ imageProps, onClick, showImage = false, isBackground = false, zIndexDefault, name }) => {
    const imageRef = useRef()
    const [image, setImage] = useState(null)

    useEffect(() => {
        if (imageRef.current && typeof zIndexDefault === 'number') imageRef.current.zIndex(zIndexDefault)
    }, [zIndexDefault])

    useEffect(() => {
        if (!showImage) return
        const img = new window.Image()
        img.onload = () => {
            setImage(img)
        }
        img.crossOrigin = 'Anonymous'
        img.src = imageProps.src

        return () => {
            img.onload = null
        }
    }, [showImage, imageProps.src])

    const imageData = useImagePadding(imageProps, {
        padding: 4,
    })

    return (
        <Image
            listening={false}
            ref={imageRef}
            {...imageData}
            image={showImage ? image : null}
            name={name || `${isBackground ? 'background' : 'fill'}`}
            fill={isBackground ? '#ffffff' : showImage ? '' : imageData.fill}
            onClick={onClick}
            globalCompositeOperation={!isBackground && !showImage ? 'source-atop' : ''}
        />
    )
}

export default BackgroundLayer
